export default function scrollBack(element, rootElement) {
  let scrollBackButton = document.querySelector(".back-to-top");
  scrollBackButton.addEventListener("click", () => {
    rootElement.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

  let observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        scrollBackButton.classList.add("back-to-top--active")
      } else {
        scrollBackButton.classList.remove("back-to-top--active")
      }
    });
  });
  observer.observe(element);
}
